import React from "react";
import { won } from "./LaonaProjects";

/* =========================================================
   펌웨어 개발의뢰 — 상태 색과 비용 · 범위 안내 (백엔드 app/laona_fw.py).
   2026-11 부터 따로 의뢰하는 팝업은 없다. 내 프로젝트 [장바구니에 담기] 팝업(LaonaOrder.jsx)의 [펌웨어 개발 옵션]에
   체크하고 담으면, 라오나 에디터의 [기능정의]에서 쓰고 [완료]로 저장한 기능정의서 + 모듈 목록 + 연결 리스트로
   의뢰가 만들어지고 빌드비가 부품과 함께 장바구니에 담긴다. 입금이 확인되면 라오나빌드서버가 의뢰를 가져가고,
   개발 · 빌드는 운영자가 직접 한다.
   ========================================================= */

export const FW_STATUS_TONE = { REQUESTED: "wait", ORDERED: "on", RECEIVED: "on", IN_PROGRESS: "on", DONE: "done", CANCELLED: "" };

/* 비용 · 범위 안내 — 의뢰 팝업과 주문 팝업이 함께 쓴다 */
export function FwTerms({ fee }) {
  return (
    <ul className="lb-fw__terms">
      <li>
        펌웨어 개발·빌드 비용은 <b>기본 {won(fee)}</b>이며, 작업량에 따라 추가 비용이 최대 10만원까지 발생할 수 있습니다.
        다만 일반적으로 추가 비용은 발생하지 않습니다.
      </li>
      <li>펌웨어는 바이너리를 포함해 코드 전체를 제공합니다.</li>
      <li>기능정의서에 적힌 기능만 구현됩니다. 기능정의서에 상세히 기재될수록 펌웨어 동작 정확도가 올라갑니다.</li>
      <li>수정을 요청하면 추가 비용이 발생합니다.</li>
    </ul>
  );
}
